import styled from 'styled-components';
import { IconSort, IconSorted, IconSortedDesc } from '~/assets/svgs';

export const Container = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`;

export const THead = styled.thead``;

export const TBody = styled.tbody``;

export const HeadRow = styled.tr`
  height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid rgba(198, 204, 210, 0.3);
`;

export const Row = styled.tr`
  height: 7.2rem;
  padding: 0 20px;
  background-color: #00000000;
  position: relative;
  border-bottom: 0.5px solid rgba(198, 204, 210, 0.3);
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

  :hover {
    background-color: #00000007;
  }
  :last-child {
    border: none;
  }
  transition: 100ms ease;
`;

export const TH = styled.th`
  padding: 5px 5px;
  color: #606474;
  font-size: 1.6rem;
  font-weight: 400;
  text-align: left;

  position: relative;
  :first-child {
    padding-left: 30px;
  }
  :last-child {
    padding-right: 10px;
  }
`;

export const TD = styled.td`
  padding: 5px 5px;
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 1.4rem;
  font-weight: 400;
  white-space: nowrap;

  :first-child {
    padding-left: 30px;
  }
  :last-child {
    padding-right: 10px;
  }
`;

export const Sort = styled(IconSort)`
  fill: #979797;
  opacity: 0;
  ${TH}:hover & {
    opacity: 1;
  }
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 1rem;
  transition: 200ms ease;
`;

export const Sorted = styled(IconSorted)`
  fill: #979797;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 1rem;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: 200ms ease;
`;

export const SortedDesc = styled(IconSortedDesc)`
  fill: #979797;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 1rem;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: 200ms ease;
`;

export const WrapperNavigator = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  padding: 0 30px;

  @media (max-width: 600px) {
    position: fixed;
    width: 100vw;
  }
`;

export const TotalItems = styled.div`
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 1.8rem;
  font-weight: 600;
`;
